import { Form, Formik } from 'formik'
import React from 'react'
import { required } from '../utils/validators'
import Input from './common/Input'
import Button from './common/Button'

export default function SalesChannelForm({ onSubmit, onCancel, loading, initialValues }) {
    return (
        <Formik initialValues={{ name: '', ...initialValues }} onSubmit={onSubmit}>
            <Form>
                <Input
                    name="name"
                    disabled={loading}
                    validate={required}
                    placeholder="Введите имя канала" />

                <Button
                    loading={loading}
                    text="Сохранить"
                    type="submit"
                    icon="ion-md-checkmark"
                    className="is-success" /> &nbsp;

                <Button
                    onClick={onCancel}
                    icon="ion-md-close"
                    text="Отмена"
                    className="is-danger" />
            </Form>
        </Formik>
    )
}
